import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CartContext } from '../context/CartContext';
//import { pundits } from '../data/mockData';
import Card from '../components/Card';

const PunditsPage = () => {
  const { cart, total } = useContext(CartContext);

  return (
    <div className="pp-main-container">
      <header className="page-header">
        <motion.h1 initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
          Our Expert Pundits
        </motion.h1>
        <p>Connect with verified and experienced Vedic scholars.</p>
      </header>

      {/* <motion.div 
        className="pp-grid"
        initial="hidden" animate="show"
        variants={{ hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.1 } } }}
      >
        {pundits.map(pundit => (
          <Card key={pundit.id} item={{ ...pundit, type: 'pundit' }} showAddToCart={true} />
        ))}
      </motion.div> */}
    </div>
  );
};

export default PunditsPage;